import React, { useState } from 'react'
// import ReactDOM from 'react-dom'
import { compose } from 'recompose'
// import Script from 'react-load-script'
import { Button, message } from 'antd'
import { injectIntl, FormattedMessage } from 'react-intl'
import { withRouter } from 'react-router'
import { graphql } from 'react-apollo'
import _get from 'lodash/get'
// import moment from 'moment'
import payRegistrationMutation from '~/App/graphql/mutations/payRegistration.gql'
import TransferModal from './TransferModal'
import { Block } from '../styles'
// import { inject, observer } from 'mobx-react'
const Transfer = compose(
  // inject('i18n'),
  injectIntl,
  withRouter,
  graphql(payRegistrationMutation, {
    name: 'payRegistration'
  })
  // observer
)(({ intl, history, registration, payRegistration, discounted, gatewayRate, gatewaySettings, systemFee, totalSystemFee, itemsDiscounted, bankAccountInfo }) => {
  const totalAmount = discounted + itemsDiscounted
  const fee = Math.round(gatewayRate * discounted * 100) / 100
  const finalAmount = totalAmount + fee
  const [paymentLoading, setPaymentLoading] = useState(false)
  const [modalVisible, setModalVisible] = useState(false)

  const handleCheckout = async checkoutData => {
    setPaymentLoading(true)
    try {
      const { data } = await payRegistration({
        variables: {
          record: {
            registrationId: registration._id,
            eventId: registration.eventId,
            method: 'transfer',
            data: {
              transfer: checkoutData
            }
          }
        }
      })
      const { registrationId } = _get(data, 'payRegistration.record')
      if (registrationId) {
        history.push(`/reg/${registrationId}`)
      }
    } catch (err) {
      const { graphQLErrors } = err
      if (graphQLErrors) {
        graphQLErrors.forEach(error => {
          message.error(intl.formatMessage({ id: `api.${error.message}` }))
        })
      } else {
        message.error(err.message)
      }
    } finally {
      setPaymentLoading(false)
    }
  }

  return <Block>
    <div className="title">
      <FormattedMessage id="paymentMethod.transfer" />
    </div>
    <div>
      {systemFee
        ? <React.Fragment>
          <FormattedMessage id="app.entryFeeBaht" defaultMessage="Entry Fee {amount} Baht" tagName="div" values={{
            amount: intl.formatNumber(discounted - totalSystemFee)
          }} />
          <FormattedMessage id="app.processingFeeBaht" defaultMessage="Processing Fee {amount} Baht" tagName="div" values={{
            amount: intl.formatNumber(totalSystemFee)
          }} />
        </React.Fragment>
        : <FormattedMessage id="app.entryFeeBaht" defaultMessage="Entry Fee {amount} Baht" tagName="div" values={{
          amount: intl.formatNumber(discounted)
        }} />
      }
      <FormattedMessage id="app.paymentProcessingFeeBaht" defaultMessage="Processing Fee" values={{
        amount: intl.formatNumber(fee)
      }} />
      {itemsDiscounted > 0 && <FormattedMessage id="app.itemsAmountBaht" defaultMessage="Extra Products {amount} Baht" tagName="div" values={{
        amount: intl.formatNumber(itemsDiscounted)
      }} />}
    </div>
    {/* <div>
      <FormattedMessage id="app.processingFeeTesco" defaultMessage="Processing Fee" />
    </div> */}
    <Button
      type="primary"
      onClick={() => setModalVisible(true)}
      loading={paymentLoading}
      className="paymentButton"
    >
      <FormattedMessage id="app.payBaht" values={{
        amount: intl.formatNumber(finalAmount)
      }} />
    </Button>
    <TransferModal
      bankAccountInfo={bankAccountInfo}
      amount={finalAmount}
      visible={modalVisible}
      loading={paymentLoading}
      onCheckout={handleCheckout}
      onClose={() => setModalVisible(false)}
      // locale={locale}
    />
  </Block>
})

export default Transfer



// WEBPACK FOOTER //
// ./src/App/components/PaymentBlocks/Transfer/Transfer.js